import { fetcher } from "@/utils/api"
import { useInfiniteQuery } from "@tanstack/react-query"
import { NotificationCategory } from "../types/notificationCategory"
import { TNotificationResponse } from "../types/notificationResponse"
import { NotificationScope } from "../types/notificationScope"

export const useNotifications = (
  scope: NotificationScope,
  category: NotificationCategory,
) => {
  const limit = 20

  const { data, isSuccess, isError, ...rest } =
    useInfiniteQuery<TNotificationResponse>({
      queryKey: ["notifications", { scope, category }],
      queryFn: async ({ pageParam: skip }): Promise<TNotificationResponse> => {
        const url: string = `/notifications/v2?skip=${skip}&limit=${limit}&scope=${scope}&category=${category}`
        const response: TNotificationResponse = await fetcher(url)
        if (!response) {
          throw new Error("No response data")
        }
        return response
      },
      initialPageParam: 0,
      getNextPageParam: (lastPage) => {
        if (!lastPage) {
          return undefined
        }
        return lastPage.has_next ? lastPage.next_skip : undefined
      },
    })

  let notifications = []
  if (isSuccess) {
    notifications = data.pages.flatMap((page) => page?.data)
  }

  return { notifications, isError, ...rest }
}
